import { Pipe, PipeTransform } from '@angular/core';
import { LanguagesService } from '@client/app/modules/languages-ng2/languages.service';

@Pipe({
    name: 'translateLanguage',
    standalone: false,
})
export class TranslateLanguagePipe implements PipeTransform {
    constructor (private languagesService: LanguagesService) {}

    transform (locale: any): string {
        return this.languagesService.getLanguage(locale) || '';
    }
}
